import React from 'react'
import Logo from '../assets/MALogo.svg'

const ConstructionPage = () => {
    return (
        <div className='wrapper'>
        <div className='d-flex flex-column justify-content-center align-items-center' style={{minHeight: '100vh'}}>
            <div className='d-flex mb-3' style={{cursor: 'pointer'}} onClick={() => window.location.href='/'}>
                <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
                {/* <h2 style={{fontWeight: 600}}>Melee Academy</h2> */}
            </div>
            <h3>Under Construction</h3>
            <p className='text-center col-10 col-md-8' style={{fontWeight: 300}}>
                We're working hard to bring this page to life! As we're still in beta, some pages are being prioritized and will be available soon. Thank you for your patience and understanding.
            </p>
            <button
            className='rounded mt-3'
            style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, width: "150px"}}
            onClick={() => window.location.href='/'}
            >
            Go Home
            </button>
        </div>
        </div>
    )
}

export default ConstructionPage